/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const ArrowCcwBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path d="m11.46 2.182.792.639a.5.5 0 0 1 .082.695L10.421 6.04l.005.045a7.999 7.999 0 0 1 9.57 8.073 8 8 0 0 1-15.982.24.477.477 0 0 1 .486-.498l.892.003a.534.534 0 0 1 .518.502 6.108 6.108 0 1 0 4.719-6.428l.005.052 2.438 1.957a.5.5 0 0 1 .058.725l-.676.749a.5.5 0 0 1-.685.054L7.022 7.687a.5.5 0 0 1-.076-.703l3.81-4.727a.5.5 0 0 1 .703-.075Z" /></svg>);
const ArrowCcw = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={ArrowCcwBase} {...rest} ref={ref} />);
export default ArrowCcw;